<template>
  <div>
    <base-title
      :title="StringLanguage.users"
      :subtitle="'Minha conta'"
      :link="'minha-conta'"
    />
    <div>
      <div v-if="aUsers.length > 0"> <!-- Se tiver usuários -->
        <div class="row user-container">
          <div class="col-lg-4 col-xs-12" v-for="(oUser, iUser) in aUsers" :key="iUser">
            <base-box class="cursor-pointer mb_15"> <!-- Para cada usuário -->
                <users-card :showDelete="aUsers.length > 1" @deleteUser="deleteUser" @editUser="openEditUser" :oUser="oUser" :currentUser="currentUser"/>
            </base-box>
          </div>
          <div class="col-lg-4 col-xs-12" >
            <base-add :text="StringLanguage.linkUser" :height="'120px'" @click.native="openAddUser"/>
          </div>
        </div>
      </div>
      <div v-else> <!--  -->
        <p>{{StringLanguage.nobodyLinked}}</p>
      </div>
    </div>
    <base-drawer ref="drawer" :open="open" :close="close" :title="selectedUser.id ? StringLanguage.editUser : StringLanguage.linkUser">
      <users-form v-if="$refs.drawer && $refs.drawer.status === 'opened'" ref="user" @newUser="newUser" @editUser="editUser" @userDeleted="userDeleted" :selectedUser="selectedUser" :userError="userError" @setUserError="setUserError" />

      <template v-slot:footer>
          <div class="d-flex">
            <base-button
                v-if="selectedUser.id"
                class="mr_15"
                design="four"
                @click.prevent="deleteUser()"
                :title="StringLanguage.removeUser"
            >
            <i class="far fa-trash-alt fs-12"></i>
          </base-button>
            <base-button @click="saveUser()" :text="selectedUser.id ? StringLanguage.save : StringLanguage.create" class="w-100"/>
          </div>
      </template>
    </base-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UsersCard from "@/containers/Users/UsersCard"
import UsersForm from "@/containers/Users/UsersForm"
import UserAPI from "@/api/user"
import customStorage from '@/plugins/customStorage'
import { Role } from 'easyjs/lib/Role/Group'

import BaseTitle from "@/components/Title"
import BaseBox from "@/components/Box"
import BaseButton from "@/components/Button"
import BaseDrawer from "@/components/Drawer"
import BaseAdd from "@/components/Add"

export default {
  data() {
    return {
      open: false,
      selectedUser: {},
      close: false,
      aUsers: [],
      userError: null
    }
  },
  created() {
    return UserAPI.list().then((response) => {
      this.aUsers = response.getData([])
      return this.aUsers
    });
  },
  computed: {
    ...mapState({
      currentUser: state => state.account.oUser,
    })
  },
  methods: {
    list: function() {
      let self = this
      return UserAPI.list().then((response) => {
          self.aUsers = response.getData([])
      })
    },
    newUser: function(oUser){
      this.close = !this.close;
      this.list();
    },
    editUser: function(oUser){
      this.list();
      this.close = !this.close;
      this.selectedUser = {};
    },
    openAddUser: function(){
      this.selectedUser = {};

      this.open = !this.open;
    },
    setUserError: function(prop){
      this.userError = prop;
    },
    openEditUser: function(oUser){
      if ([Role.ADMIN, Role.MASTER].includes(this.currentUser.group)) {
        this.selectedUser = { ...oUser, currentGroup: oUser.group };
        this.userError = null;
        this.open = !this.open;
      }
    },
    deleteUser: function(){
      this.$refs.user.del()
    },
    saveUser: function() {
      this.$refs.user.soe()
    },
    userDeleted: function() {
        this.close = !this.close
        this.list();
    }
  },
  components: {
    UsersCard,
    UsersForm,
    BaseTitle,
    BaseBox,
    BaseButton,
    BaseDrawer,
    BaseAdd
  }
}
</script>
<style scoped>
  @media screen and (min-width: 992px) {
    .user-container > * {
      padding-right: 0;
    }
  }
</style>